import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "@widgets/header/ui/Header";
import Home from "@pages/Home";
import Catalog from "@pages/Catalog";
import Product from "@pages/Product";
import Footer from "@widgets/footer/ui/Footer";
import ComingSoon from "@pages/ComingSoon"; // Добавляем страницу "В разработке"
import SearchPage from "@pages/SearchPage";
import WooCategoriesGrid from "./pages/CatalogNew";
function App() {
  return (
    <BrowserRouter>
      <div className="App px-[10px] md:px-0">
        <Header />
        <Routes>
          {/* Перенаправляем "/" на "/home" */}
          {/*<Route path="/" element={<ComingSoon />} />*/}
          
          {/* Основные страницы */}
          <Route path="/" element={<Home />} />
          <Route path="/catalog/:categorySlug" element={<Catalog />} />
          <Route path="/product/:productId" element={<Product />} />
          <Route path="/catalog" element={<WooCategoriesGrid/>} />
          {/* Страница "В разработке" */}
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/search" element={<SearchPage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
